import { Component, OnInit } from '@angular/core';
import { CourseService } from '@scaffold/services/course.service';
import { PageTitleService } from '@services/page-title.service';
import { UserService } from '@services/user.service';

@Component({
  selector: 'app-document-select',
  templateUrl: './document-select.component.html',
  styleUrl: './document-select.component.scss',
  standalone: false,
})
export class DocumentSelectComponent implements OnInit {
  view: any;
  documents = [];

  constructor(
    private pageTitleService: PageTitleService,
    private userService: UserService,
    private courseService: CourseService
  ) {}
  ngOnInit() {
    this.courseService
      .get('sis_bdm_root_folder/select?mode=read')
      .subscribe(c => {
        if (c != null) {
          this.view = c;
        }
      });
    this.pageTitleService.section = 'Documents';
  }
}
